import lottie from 'lottie-web/build/player/lottie';

/**
 * Initializes one Lottie player block instance.
 *
 * @param {HTMLElement} block Block root element.
 *
 * @return {void}
 */
const initializeLottiePlayer = ( block ) => {

	const animationContainer = block.querySelector( '.b-lottie-player__animation' );
	if ( ! animationContainer || animationContainer.dataset.lottieInitialized === 'true' ) {

		return;

	}

	const animationPath = animationContainer.dataset.lottieJson;
	if ( ! animationPath ) {

		return;

	}

	const shouldLoop = animationContainer.dataset.lottieLoop !== 'false';
	lottie.loadAnimation( {
		container: animationContainer,
		renderer: 'svg',
		loop: shouldLoop,
		autoplay: true,
		path: animationPath,
	} );

	animationContainer.dataset.lottieInitialized = 'true';

};

document.querySelectorAll( '.b-lottie-player' ).forEach( ( block ) => {

	initializeLottiePlayer( block );

} );

const observer = new MutationObserver( ( records ) => {

	records.forEach( ( record ) => {

		record.addedNodes.forEach( ( node ) => {

			if ( ! ( node instanceof HTMLElement ) ) {

				return;

			}

			if ( node.matches( '.b-lottie-player' ) ) {

				initializeLottiePlayer( node );

			}

			node.querySelectorAll?.( '.b-lottie-player' ).forEach( ( block ) => {

				initializeLottiePlayer( block );

			} );

		} );

	} );

} );

if ( document.body ) {

	observer.observe( document.body, {
		childList: true,
		subtree: true,
	} );

}
